import React from 'react';
import { Link } from 'react-router-dom';
import HeroSection from '../components/HeroSection';
import SectionTitle from '../components/SectionTitle';
import FeatureCard from '../components/FeatureCard';
const CasesPage = () => {
  const caseCategories = [{
    id: 'llm',
    title: '大模型服务应用案例',
    description: '基于PH8大模型平台的企业应用案例，涵盖金融、法律、客服等多个领域',
    cases: [{
      id: 'case1',
      title: '金融行业智能风控系统',
      description: '为某大型银行构建基于大模型的智能风控系统，提高风险识别准确率40%，减少人工审核时间60%。',
      image: 'https://images.unsplash.com/photo-1601597111158-2fceff292cdc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
    }, {
      id: 'case2',
      title: '智能客服升级项目',
      description: '帮助某电商平台升级智能客服系统，接入大模型能力，提升复杂问题解决率35%，客户满意度提升25%。',
      image: 'https://images.unsplash.com/photo-1549923746-c502d488b3ea?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2071&q=80'
    }, {
      id: 'case3',
      title: '法律文档智能分析系统',
      description: '为某律师事务所开发法律文档智能分析系统，自动提取关键信息和风险点，提高工作效率50%以上。',
      image: 'https://images.unsplash.com/photo-1589829085413-56de8ae18c73?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2012&q=80'
    }]
  }, {
    id: 'computing',
    title: '异构算力综合服务案例',
    description: '基于普华云异构算力平台的高性能计算应用案例',
    cases: [{
      id: 'case1',
      title: '大规模AI模型训练平台',
      description: '为某研究机构提供大规模分布式训练平台，支持千亿参数模型训练，训练速度提升3倍。',
      image: 'https://images.unsplash.com/photo-1581093450021-a7e9e5e3df6f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
    }]
  }, {
    id: 'all-in-one',
    title: '一体机服务应用案例',
    description: '基于AI一体机解决方案的落地应用案例',
    cases: [{
      id: 'case1',
      title: '医疗影像智能诊断系统',
      description: '为某三甲医院提供医疗影像AI辅助诊断系统，准确率达95%以上，大幅提升诊断效率和准确性。',
      image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
    }]
  }, {
    id: 'chip-testing',
    title: 'AI芯片性能测试案例',
    description: '国产AI芯片性能测试和优化案例',
    cases: [{
      id: 'case1',
      title: '国产AI芯片性能评估项目',
      description: '为某芯片厂商提供全面的性能测试和优化服务，帮助其产品在特定场景下性能提升35%。',
      image: 'https://images.unsplash.com/photo-1591405351990-4726e331f141?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
    }, {
      id: 'case2',
      title: '边缘AI部署优化项目',
      description: '帮助某安防设备厂商优化AI模型在国产边缘芯片上的部署，降低功耗50%，提高推理速度3倍。',
      image: 'https://images.unsplash.com/photo-1563770660941-10a63607692e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
    }]
  }];
  return <div className="bg-white" data-id="element-401">
      <HeroSection title="成功案例" subtitle="我们已成功帮助众多企业实现数字化转型，以下是部分客户的成功案例" backgroundImage="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" size="medium" data-id="element-402" />
      <section className="py-16 md:py-24" data-id="element-403">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-404">
          <SectionTitle title="客户成功案例" subtitle="探索我们如何帮助各行业客户解决实际业务挑战，实现数字化转型" data-id="element-405" />
          <div className="space-y-20" data-id="element-406">
            {caseCategories.map(category => <div key={category.id} className="space-y-8" data-id="element-407">
                <SectionTitle title={category.title} subtitle={category.description} alignment="left" titleSize="medium" data-id="element-408" />
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-409">
                  {category.cases.map(caseItem => <FeatureCard key={caseItem.id} title={caseItem.title} description={caseItem.description} image={caseItem.image} variant="bordered" link={`/cases/${category.id}/${caseItem.id}`} data-id="element-410" />)}
                </div>
              </div>)}
          </div>
        </div>
      </section>
      <section className="py-16 md:py-24 bg-gray-50" data-id="element-411">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-412">
          <div className="max-w-3xl mx-auto text-center" data-id="element-413">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-414">
              客户见证
            </h2>
            <div className="mb-10" data-id="element-415">
              <div className="relative" data-id="element-416">
                <svg className="absolute top-0 left-0 transform -translate-x-6 -translate-y-8 h-16 w-16 text-gray-200" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-417">
                  <path d="M7.39762 10.3C7.39762 11.0733 7.14888 11.7 6.6514 12.18C6.15392 12.6333 5.52552 12.86 4.76621 12.86C3.84979 12.86 3.09047 12.5533 2.48825 11.94C1.91222 11.3266 1.62421 10.4467 1.62421 9.29999C1.62421 8.07332 1.96459 6.87332 2.64535 5.69999C3.35231 4.49999 4.33418 3.55332 5.59098 2.85999L6.4943 4.25999C5.81354 4.73999 5.26369 5.27332 4.84476 5.85999C4.45201 6.44666 4.19017 7.12666 4.05926 7.89999C4.29491 7.79332 4.56983 7.73999 4.88403 7.73999C5.61716 7.73999 6.21938 7.97999 6.68996 8.45999C7.16054 8.93999 7.39762 9.55333 7.39762 10.3ZM14.6242 10.3C14.6242 11.0733 14.3755 11.7 13.878 12.18C13.3805 12.6333 12.7521 12.86 11.9928 12.86C11.0764 12.86 10.3171 12.5533 9.71484 11.94C9.13881 11.3266 8.85079 10.4467 8.85079 9.29999C8.85079 8.07332 9.19117 6.87332 9.87194 5.69999C10.5789 4.49999 11.5608 3.55332 12.8176 2.85999L13.7209 4.25999C13.0401 4.73999 12.4903 5.27332 12.0713 5.85999C11.6786 6.44666 11.4168 7.12666 11.2858 7.89999C11.5215 7.79332 11.7964 7.73999 12.1106 7.73999C12.8437 7.73999 13.446 7.97999 13.9166 8.45999C14.3872 8.93999 14.6242 9.55333 14.6242 10.3Z" fill="currentColor" data-id="element-418" />
                </svg>
                <div className="relative z-10" data-id="element-419">
                  <p className="text-xl text-gray-700 italic mb-4" data-id="element-420">
                    "与贵公司合作是我们数字化转型的重要一步。PH8大模型平台帮助我们实现了智能风控系统的升级，不仅提高了风险识别的准确性，还大幅减少了人工审核时间。专业的技术团队和优质的服务让我们的合作非常愉快。"
                  </p>
                  <div className="font-medium text-gray-900" data-id="element-421">
                    张总 | 某大型银行风控部门负责人
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-10" data-id="element-422">
              <div className="relative" data-id="element-423">
                <svg className="absolute top-0 left-0 transform -translate-x-6 -translate-y-8 h-16 w-16 text-gray-200" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-424">
                  <path d="M7.39762 10.3C7.39762 11.0733 7.14888 11.7 6.6514 12.18C6.15392 12.6333 5.52552 12.86 4.76621 12.86C3.84979 12.86 3.09047 12.5533 2.48825 11.94C1.91222 11.3266 1.62421 10.4467 1.62421 9.29999C1.62421 8.07332 1.96459 6.87332 2.64535 5.69999C3.35231 4.49999 4.33418 3.55332 5.59098 2.85999L6.4943 4.25999C5.81354 4.73999 5.26369 5.27332 4.84476 5.85999C4.45201 6.44666 4.19017 7.12666 4.05926 7.89999C4.29491 7.79332 4.56983 7.73999 4.88403 7.73999C5.61716 7.73999 6.21938 7.97999 6.68996 8.45999C7.16054 8.93999 7.39762 9.55333 7.39762 10.3ZM14.6242 10.3C14.6242 11.0733 14.3755 11.7 13.878 12.18C13.3805 12.6333 12.7521 12.86 11.9928 12.86C11.0764 12.86 10.3171 12.5533 9.71484 11.94C9.13881 11.3266 8.85079 10.4467 8.85079 9.29999C8.85079 8.07332 9.19117 6.87332 9.87194 5.69999C10.5789 4.49999 11.5608 3.55332 12.8176 2.85999L13.7209 4.25999C13.0401 4.73999 12.4903 5.27332 12.0713 5.85999C11.6786 6.44666 11.4168 7.12666 11.2858 7.89999C11.5215 7.79332 11.7964 7.73999 12.1106 7.73999C12.8437 7.73999 13.446 7.97999 13.9166 8.45999C14.3872 8.93999 14.6242 9.55333 14.6242 10.3Z" fill="currentColor" data-id="element-425" />
                </svg>
                <div className="relative z-10" data-id="element-426">
                  <p className="text-xl text-gray-700 italic mb-4" data-id="element-427">
                    "普华云异构算力平台为我们提供了强大的计算支持，使我们能够高效训练和部署大规模AI模型。平台的稳定性和性能表现令人印象深刻，技术团队的专业支持也帮助我们解决了许多挑战。"
                  </p>
                  <div className="font-medium text-gray-900" data-id="element-428">
                    李教授 | 某研究院AI研究中心主任
                  </div>
                </div>
              </div>
            </div>
            <div data-id="element-429">
              <div className="relative" data-id="element-430">
                <svg className="absolute top-0 left-0 transform -translate-x-6 -translate-y-8 h-16 w-16 text-gray-200" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-431">
                  <path d="M7.39762 10.3C7.39762 11.0733 7.14888 11.7 6.6514 12.18C6.15392 12.6333 5.52552 12.86 4.76621 12.86C3.84979 12.86 3.09047 12.5533 2.48825 11.94C1.91222 11.3266 1.62421 10.4467 1.62421 9.29999C1.62421 8.07332 1.96459 6.87332 2.64535 5.69999C3.35231 4.49999 4.33418 3.55332 5.59098 2.85999L6.4943 4.25999C5.81354 4.73999 5.26369 5.27332 4.84476 5.85999C4.45201 6.44666 4.19017 7.12666 4.05926 7.89999C4.29491 7.79332 4.56983 7.73999 4.88403 7.73999C5.61716 7.73999 6.21938 7.97999 6.68996 8.45999C7.16054 8.93999 7.39762 9.55333 7.39762 10.3ZM14.6242 10.3C14.6242 11.0733 14.3755 11.7 13.878 12.18C13.3805 12.6333 12.7521 12.86 11.9928 12.86C11.0764 12.86 10.3171 12.5533 9.71484 11.94C9.13881 11.3266 8.85079 10.4467 8.85079 9.29999C8.85079 8.07332 9.19117 6.87332 9.87194 5.69999C10.5789 4.49999 11.5608 3.55332 12.8176 2.85999L13.7209 4.25999C13.0401 4.73999 12.4903 5.27332 12.0713 5.85999C11.6786 6.44666 11.4168 7.12666 11.2858 7.89999C11.5215 7.79332 11.7964 7.73999 12.1106 7.73999C12.8437 7.73999 13.446 7.97999 13.9166 8.45999C14.3872 8.93999 14.6242 9.55333 14.6242 10.3Z" fill="currentColor" data-id="element-432" />
                </svg>
                <div className="relative z-10" data-id="element-433">
                  <p className="text-xl text-gray-700 italic mb-4" data-id="element-434">
                    "医疗影像AI辅助诊断系统的部署大大提升了我院的诊断效率和准确性。一体机的设计使我们能够快速部署和使用系统，无需复杂的IT基础设施改造。这是我们医疗数字化转型的重要一步。"
                  </p>
                  <div className="font-medium text-gray-900" data-id="element-435">
                    王主任 | 某三甲医院放射科
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="py-16 md:py-24" data-id="element-436">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-437">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-438">
            您的成功故事将会是下一个
          </h2>
          <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto" data-id="element-439">
            无论您的业务需求是什么，我们的专业团队都将为您提供最适合的AI解决方案，帮助您实现业务目标。
          </p>
          <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-440">
            <Link to="/about/contact" className="inline-block bg-primary-600 hover:bg-primary-700 text-white font-medium py-3 px-8 rounded-md transition duration-300" data-id="element-441">
              联系我们
            </Link>
            <Link to="/solutions" className="inline-block bg-white text-primary-600 font-medium py-3 px-8 rounded-md border border-primary-600 transition duration-300 hover:bg-primary-50" data-id="element-442">
              探索解决方案
            </Link>
          </div>
        </div>
      </section>
    </div>;
};
export default CasesPage;